enum CandidateViewingStatus {
    NotInvited = 'not_invited',
    Pending = 'pending',
    Accepted = 'accepted',
    Declined = 'declined',
}

export default CandidateViewingStatus
